module.exports = __webpack_public_path__ + "img/7_lead_strategist.811b0cc1.png";